import { render, staticRenderFns } from "./BDXStatusPendingPreviewModal.vue?vue&type=template&id=455d73c7&scoped=true"
import script from "./BDXStatusPendingPreviewModal.vue?vue&type=script&lang=js"
export * from "./BDXStatusPendingPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusPendingPreviewModal.vue?vue&type=style&index=0&id=455d73c7&prod&lang=css"
import style1 from "./BDXStatusPendingPreviewModal.vue?vue&type=style&index=1&id=455d73c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d73c7",
  null
  
)

export default component.exports